module.exports = __webpack_public_path__ + "static/img/build6.aaf6b274.png";